import React from 'react';
import { withRouter } from 'react-router';
import { Translation, getI18n } from 'react-i18next';
import { Tabs } from 'antd';
import Logger from '../../../../../lib/Logger';
import CognitoFormsAdminList from '../containers/CognitoFormsAdminListContainer';
import QueryString from '../../../../../lib/QueryString';
import notification from '../../../elements/lib/NotificationWrapper';
import { PublicStatusFormTag } from '../../../elements/components/Tags';
import Format from '../../../../../lib/Format';
import ListAction from './ListAction';
import { mixpanelEventsEnum } from '../../../../../lib/Mixpanel';

const CognitoFormsAdminListTabs = ({
  component,
  page,
  limit,
  order,
  filter,
  history,
  patch,
  partnershipId,
  load,
  remove,
  showForm,
  trackerActions,
  ...props
}) => {
  const changeFilterTab = (key) => {
    const path = props.location.pathname;
    const params = QueryString.parse(props.location.search);
    params.type = key;
    history.push(QueryString.append(path, params));
    trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.COGNITO_FORMS_ADMIN_CHANGE_TAB
    );
  };

  const handleDisabled = (id, public_status, page, limit, order, filter) => {
    trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.COGNITO_FORMS_TOGGLE_STATUS
    );
    patch(partnershipId, id, { public_status: public_status }, (success) => {
      if (success) {
        load(partnershipId, page, limit, order, filter);
        if (public_status === 1) {
          notification.success(
            getI18n().t('cognito_forms_button_update_enabled_success')
          );
        } else {
          notification.success(
            getI18n().t('cognito_forms_button_update_disabled_success')
          );
          load(partnershipId, page, limit, order, filter);
        }
      } else {
        notification.error(getI18n().t('feedback_form_error'));
      }
    });
  };

  const handleDelete = (id) => {
    trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.COGNITO_FORMS_ADMIN_DELETE
    );

    remove(partnershipId, id, (success) => {
      if (success) {
        load(partnershipId, page, limit, order, filter);
        notification.success(
          getI18n().t('cognito_forms_button_delete_success')
        );
      } else {
        notification.error(getI18n().t('cognito_forms_button_delete_failure'));
      }
    });
  };

  const allColumns = {
    base: [
      {
        title: getI18n().t('cognito_form_admin_name'),
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: getI18n().t('cognito_form_admin_form_id'),
        dataIndex: 'form_id',
        key: 'form_id',
      },
      {
        title: getI18n().t('cognito_form_admin_form_key'),
        dataIndex: 'form_key',
        key: 'form_key',
      },
      {
        title: getI18n().t('cognito_form_admin_created_by'),
        dataIndex: 'profile_name',
        key: 'profile_name',
      },
      {
        title: getI18n().t('cognito_form_admin_public_status'),
        dataIndex: 'public_status',
        key: 'public_status',
        render: (code) => <PublicStatusFormTag status={code} />,
      },
      {
        title: getI18n().t('table_header_updated_at'),
        dataIndex: 'updated_at',
        key: 'updated_at',
        render: (date) => Format.date(date),
        defaultSortOrder:
          order === 'updated_at.asc'
            ? 'ascend'
            : order === 'updated_at.desc'
            ? 'descend'
            : null,
        sorter: true,
      },
    ],
    onboarding: [
      {
        title: getI18n().t('cognito_form_admin_registration_code_alias'),
        dataIndex: 'code_alias',
        key: 'code_alias',
      },
      {
        title: getI18n().t('cognito_form_admin_registration_code'),
        dataIndex: 'code',
        key: 'code',
      },
    ],
    internal: [],
    survey: [],
    actions: [
      {
        title: getI18n().t('table_header_action'),
        key: 'actions',
        width: 77,
        fixed: 'right',
        render: (row) => (
          <ListAction
            row={row}
            page={page}
            limit={limit}
            order={order}
            filter={filter}
            handleDisabled={handleDisabled}
            handleDelete={handleDelete}
            showForm={showForm}
            trackerActions={trackerActions}
          />
        ),
      },
    ],
  };

  const getColumnsByType = (type) => [
    ...(allColumns[type] || []),
    ...allColumns.base,
    ...allColumns.actions,
  ];

  return (
    <Translation>
      {(t) => (
        <>
          <Tabs
            style={{ marginTop: '20px' }}
            destroyInactiveTabPane={true}
            onChange={changeFilterTab}
            type='card'
            className='cognito-form-tabs'
          >
            <Tabs.TabPane
              destroyInactiveTabPane={true}
              tab={t('cognito_forms_admin_tab_onboarding_form')}
              key={1}
            >
              <CognitoFormsAdminList
                component={component}
                page={page}
                limit={limit}
                order={order}
                filter={filter}
                columns={getColumnsByType('onboarding')}
                trackerActions={trackerActions}
              />
            </Tabs.TabPane>
            <Tabs.TabPane
              destroyInactiveTabPane={true}
              tab={t('cognito_forms_admin_tab_internal_forms')}
              key={2}
            >
              <CognitoFormsAdminList
                component={component}
                page={page}
                limit={limit}
                order={order}
                filter={filter}
                columns={getColumnsByType('internal')}
                trackerActions={trackerActions}
              />
            </Tabs.TabPane>
            <Tabs.TabPane
              destroyInactiveTabPane={true}
              tab={t('cognito_forms_admin_tab_surveys')}
              key={3}
            >
              <CognitoFormsAdminList
                trackerActions={trackerActions}
                component={component}
                page={page}
                limit={limit}
                order={order}
                filter={filter}
                columns={getColumnsByType('survey')}
              />
            </Tabs.TabPane>
          </Tabs>
        </>
      )}
    </Translation>
  );
};

export default withRouter(CognitoFormsAdminListTabs);

Logger.log('silly', `CognitoFormsAdminListTabs loaded.`);
